import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 335px;
  min-height: 40px;
  max-height: 50px;
  height: 50px;
  display: flex;
  background: ${props => props.theme['text-field-background']};
  border-radius: 5px;
  > div:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  > div:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  @media (max-width: 500px) {
    max-height: 40px;
  }
`;

export const Option = styled.div`

`;

export const OptionIcon = styled.img`
  max-height: 24px;
  max-width: 24px;
  margin-right: 10px;
`;

export const OptionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.active ? '#C2CEFF' : 'transparent'};
  flex: 1;
  font-family: PublicSans-Regular;
  font-size: ${props => props.fontSize};
  color: ${props => (props.active ? `${props.theme['primary-color']}` : '#000000')};
  letter-spacing: 0.42px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-transform: capitalize;
`;